// @flow

import React, { type Node } from 'react';
import { GlobalStyle } from '../global-style';
import { Logo } from '../logo';
import { SuccessIcon } from '../icon';
import { Content, Footer, Main, Message, Title, Wrapper } from '../layout';
import { CanceledPaymentPage } from './canceled-payment-page';
import { type Country } from '@tectonics/prs/country';
import { useEventBusPublisher } from '@tectonics/public-event-bus';
import { Empty } from '@tectonics/components';

type RenderErrorPageProps = {|
  status: string,
  country: Country,
  error: Error,
  localTenancy?: string,
|};

export function RenderErrorPage({ status, country, error }: RenderErrorPageProps): Node {
  useEventBusPublisher('renderError:dispatch', error);

  return (
    <>
      <GlobalStyle />
      <Page status={status} country={country}/>
    </>
  );
}

type PageProps = {|
  status: string,
  country: Country,
  localTenancy?: string,
|};

function Page({ status, country}: PageProps): Node {
  switch (status) {
    case 'CO':
      return <ConfirmedPaymentPage/>;

    case 'CA':
      return <CanceledPaymentPage country={country} />;

    default:
      return <Empty />;
  }
}

const ConfirmedPaymentPage = () => (
  <Wrapper>
    <Main>
      <Content centered>
        <SuccessIcon size="5em" />
        <Title>Seu Pagamento foi aprovado!</Title>
        <Message>Você pode conferir mais informações no email de confirmação que lhe enviamos.</Message>
      </Content>
    </Main>
    <Footer>
      Pagamento seguro via <Logo/>
    </Footer>
  </Wrapper>
);
